import { combineReducers } from 'redux';
import { cart } from './Reducers/Cart.reducer';
import { quickSearch } from './Reducers/QuickSearch.reducer';
import { navigation } from './Reducers/Navigation.reducer';
import { facetedSearch } from './Reducers/FacetedSearch.reducer';
import { myPage } from './Reducers/MyPage.reducer';
import { checkout } from "./Reducers/Checkout.reducer";
import { lightboxImages } from './Reducers/LightboxImages.reducer';
import { notification } from './Reducers/Notification.reducer';
import { product } from './Reducers/Product.reducer';
import { favoriteProducts } from './Reducers/FavoriteProducts.reducer';
import { superBuilder } from './Reducers/SuperBuilder.reducer';
import { configurator } from './Reducers/Configurator.reducer';

const staticReducers = {
    cart,
    quickSearch,
    navigation,
    facetedSearch,  
    lightboxImages,
    notification,
    favoriteProducts,
    product,
    superBuilder,
    configurator,
    myPage,
    checkout
};

const app = combineReducers(staticReducers);

export const createReducer = (asyncReducers) => {
    return combineReducers({
        ...staticReducers,
        ...asyncReducers,
    });
};

export default app;
